import { asAsyncKeyMapSync } from "./asAsyncKeyMapSync.js";
export async function* asAsyncSortedKeyValuesSync(source, keySelector, ascending, comparer) {
    const map = await asAsyncKeyMapSync(source, keySelector);
    const sortedKeys = [...map.keys()].sort(comparer ? comparer : undefined);
    if (ascending) {
        for (let i = 0; i < sortedKeys.length; i++) {
            yield map.get(sortedKeys[i]);
        }
    }
    else {
        for (let i = sortedKeys.length - 1; i >= 0; i--) {
            yield map.get(sortedKeys[i]);
        }
    }
}
